import { createContext, useContext } from "react";

const FormControllerContext = createContext(undefined);
const FormControllerProvider = FormControllerContext.Provider;
const useFormControllerContext = () => useContext(FormControllerContext);

export {
    FormControllerContext,
    FormControllerProvider,
    useFormControllerContext,
};
